import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { countryDataSource } from '../../_datasource/CountryDatasource'
import type { Markets } from './Market'

export const MEASUREMENT_SYSTEMS = ['metric', 'imperial'] as const
export type MeasurementSystems = (typeof MEASUREMENT_SYSTEMS)[number]

export const MEASUREMENT_UNITS = {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
} as const

export const IMPERIAL_MARKETS: Markets[] = Array.from(
  new Set(
    Object.values(countryDataSource)
      .filter(config => config.measurementSystem === MEASUREMENT_UNITS.IMPERIAL)
      .map(config => config.market)
  )
)

export const MeasurementSystemValidation = z.object({
  value: z.enum(MEASUREMENT_SYSTEMS, { required_error: '[MeasurementSystem] value is required' }),
})

export class MeasurementSystem extends Model {
  static create({ value }: z.infer<typeof MeasurementSystemValidation>) {
    MeasurementSystemValidation.parse({ value })
    return new MeasurementSystem(value)
  }

  static metric() {
    return new MeasurementSystem('metric')
  }

  static imperial() {
    return new MeasurementSystem('imperial')
  }

  static fromJSON(json: ReturnType<MeasurementSystem['toJSON']>) {
    return MeasurementSystem.create({ value: json.value })
  }

  constructor(private readonly _value: MeasurementSystems) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isMetric(): boolean {
    return this._value === 'metric'
  }

  isImperial(): boolean {
    return this._value === 'imperial'
  }

  toJSON() {
    return { value: this._value }
  }
}
